import { COVERGO_SAAS_DEV } from "../consts.js"

export const paul_test_tenant_dev = {
	"paul-test-tenant-studio.dev.asia.covergo.cloud": {
		appConfig: {
			tenantId: "paul_test_tenant",
			appId: "covergo_crm",
		},
		envConfig: COVERGO_SAAS_DEV,
	}
}
